import { redo } from "prosemirror-history";

export default class RedoButton {
	constructor(editorView, containerElement) {
		this.view = editorView;
		this.buttonElement = document.createElement("button");
		this.buttonElement.setAttribute("type", "button");
		this.buttonElement.className = "editor-toolbar-button";
		this.buttonElement.setAttribute("type", "button");
		this.buttonElement.dataset.action = "redo";
		this.buttonElement.title = "Rehacer";
		const iconSpan = document.createElement("span"),
			labelSpan = document.createElement("span");
		iconSpan.textContent = "Rehacer";
		labelSpan.className = "oculto-visual";
		labelSpan.textContent = "Rehacer";
		this.buttonElement.appendChild(iconSpan);
		this.buttonElement.appendChild(labelSpan);

		this.action = this.buttonClickCallback();
		this.rejectFocusAction = this.buttonMouseDownCallback();
		this.buttonElement.addEventListener("click", this.action);
		this.buttonElement.addEventListener("mousedown", this.rejectFocusAction);
		containerElement.appendChild(this.buttonElement);
		this.update(editorView);
	}

	update(view) {
		const isEnabled = redo(view.state, null);
		this.buttonElement.disabled = !isEnabled;
		this.view = view;
	}

	destroy() {
		this.buttonElement.removeEventListener("click", this.action);
		this.buttonElement.removeEventListener("mousedown", this.rejectFocusAction);
		this.buttonElement.remove();
		this.buttonAction = null;
		this.rejectFocusAction = null;
		this.buttonElement = null;
		this.view = null;
	}

	buttonMouseDownCallback() {
		return (event) => {
			event.preventDefault();
		}
	}

	buttonClickCallback() {
		return () => {
			redo(this.view.state, this.view.dispatch);
		}
	}
}